<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
                    <v-card-text>
                        <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
                            <v-container>
                                <v-row>
                                    <v-col cols="6">
                                        <ryou-input v-model="model.companyId" :value="model.companyId" :label="'会社ID'" v-show="false"></ryou-input>
                                        <ryou-input v-model="model.companyName" :value="model.companyName" :label="'会社名'" :rules="inputNameRules" :maxlength="20"></ryou-input>
                                        <!-- <v-text-field v-model="model.companyName" :value="model.companyName" :label="'会社名'">
                            </v-text-field> -->
                                    </v-col>
                                    <v-col cols="6">
                                        <ryou-input v-model="model.companyCode" :value="model.companyCode" :label="'会社略称'" :rules="inputCodeRules" :maxlength="10"></ryou-input>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :iconCls="'mdi-close'"></ryou-black-btn>
                        <v-spacer></v-spacer>
                        <ryou-black-btn :label="'登録'" :handlerClick="handleOk"></ryou-black-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import RyouInput from "@/components/formInput/RyouInput.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    export default {
        components: {
            RyouInput,
            RyouBlackBtn
        },
        mounted() {
            this.inputNameRules.push(this.GlobalRules.required);
            this.inputNameRules.push(this.GlobalRules.counter_20);
            this.inputCodeRules.push(this.GlobalRules.required);
            this.inputCodeRules.push(this.GlobalRules.counter_10);
        },
        props: {
            url: {
                type: Object,
                required: true,
                default: () => { }
            }
        },
        data: () => ({
            dialog: false,
            title: "",
            valid: true,
            inputNameRules: [],
            inputCodeRules: [],
            model: {
                companyId: "",
                companyName: "",
                companyCode: ""
            }
        }),
        methods: {
            add() {
                this.open();
                this.title = "会社マスタ新規";
            },
            edit(record) {
                this.companyId = record.companyId
                this.reg_user_id = record.reg_user_id
                this.reg_program_id = record.reg_program_id
                this.reg_date = record.reg_date
                this.open();
                this.title = "会社マスタ編集";
                setTimeout(() => {
                    this.model = Object.assign({}, record);
                }, 10);
            },
            handleOk() {
                var valid = this.$refs.p1DialogForm.validate();
                const date = new Date();
                if (valid) {
                    var that = this;
                    if (this.model.companyId) {
                        let params = {
                            companyId: this.model.companyId,
                            companyName: this.model.companyName,
                            companyCode: this.model.companyCode,
                            reg_user_id: this.reg_user_id,
                            reg_program_id: this.reg_program_id,
                            reg_date: this.reg_date,
                            upd_user_id: this.$store.getters.getUserId,
                            upd_program_id: "GC002",
                            upd_date: date
                        };
                        this.putRequest(this.url.update, params, this.$store.getters.getUserToken).then(resp => {
                            if (resp.success) {
                                that.$emit("ok");
                            }
                            that.close();
                        });
                    } else {
                        let params = {
                            companyName: this.model.companyName,
                            companyCode: this.model.companyCode,
                            reg_user_id: this.$store.getters.getUserId,
                            reg_program_id: "GC002",
                            reg_date: date,
                            upd_user_id: this.$store.getters.getUserId,
                            upd_program_id: "GC002",
                            upd_date: date
                        };
                        this.postRequest(this.url.add, params, this.$store.getters.getUserToken).then(resp => {
                            if (resp.success) {
                                that.$emit("ok");
                            }
                            that.close();
                        });
                    }
                }
            },
            handleCancel() {
                this.close();
            },
            close() {
                this.dialog = false;
            },
            open() {
                this.dialog = true;
                if (this.$refs.p1DialogForm) {
                    this.$refs.p1DialogForm.reset();
                    this.$refs.p1DialogForm.resetValidation();
                }
            }
        }
    };
</script>

<style>
</style>
